import { lazyPage, type ModulePlugin } from "@keel/core";
import { useIntegrationBadge } from "./badge";

const hub = () => import("./Hub");
const IntegrationHub = lazyPage(hub, "IntegrationHub");
const ConnectionPage = lazyPage(hub, "ConnectionPage");
const NewConnection = lazyPage(hub, "NewConnection");
const Webhooks = lazyPage(() => import("./Webhooks"), "Webhooks");

/** Integration hub: connections with health, message log and retries; webhooks. */
const plugin: ModulePlugin = {
  key: "integrations",
  help: () => import("./help"),
  nav: [
    {
      group: "Platform",
      items: [
        {
          to: "/integrations",
          label: "Integration hub",
          icon: "plug",
          perm: "integrations.messages.read",
          useBadge: useIntegrationBadge,
        },
        { to: "/webhooks", label: "Webhooks", icon: "webhook", perm: "integrations.webhooks.manage" },
      ],
    },
  ],
  routes: [
    { path: "/integrations", element: <IntegrationHub /> },
    { path: "/integrations/new", element: <NewConnection /> },
    { path: "/integrations/:id", element: <ConnectionPage /> },
    { path: "/webhooks", element: <Webhooks /> },
  ],
  commands: [
    ["Integration hub", "/integrations", "plug", "integrations.messages.read"],
    ["Connect a system", "/integrations/new", "plus", "integrations.connections.manage"],
    ["Webhooks", "/webhooks", "webhook", "integrations.webhooks.manage"],
  ],
};
export default plugin;
